<div class="classification-panel" fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="16px">
    <div class="count">{{ item.count }}</div>
    <div class="description">{{ item.dictionaryItem.name_ru }}</div>
</div>
